import { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography, Stack } from "@mui/material";
import PropTypes from 'prop-types';
import SelectPoste from "./selectPoste";

function Dimanche({ data_dimanche_pair, data_dimanche_impair, onDimancheChange, triggerResetDimanche, is_benevole }) {

  const [dimanche, setDimanche] = useState({
    c_08_10: '',
    c_09_11: '',
    c_10_12: '',
    c_11_13: '',
    c_12_14: '',
    c_13_15: '',
    c_14_16: '',
    c_15_17: '',
    c_16_18: '',
    c_18_22: '',
    repas_midi: false,
  });

  const [l_08_10, setL_08_10] = useState([]);
  const [l_09_11, setL_09_11] = useState([]);
  const [l_10_12, setL_10_12] = useState([]);
  const [l_11_13, setL_11_13] = useState([]);
  const [l_12_14, setL_12_14] = useState([]);
  const [l_13_15, setL_13_15] = useState([]);
  const [l_14_16, setL_14_16] = useState([]);
  const [l_15_17, setL_15_17] = useState([]);
  const [l_16_18, setL_16_18] = useState([]);
  const [l_18_22, setL_18_22] = useState([]);

  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du dimanche
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_08_10(data_dimanche_pair.filter((ligne) => ligne[0] && ligne[0].trim().length > 0)
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));
    setL_10_12(data_dimanche_pair.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    setL_12_14(data_dimanche_pair.filter((ligne) => ligne[8] && ligne[8].trim().length > 0)
      .map((ligne) => `${ligne[8]} (${ligne[10]}/${ligne[11]})`));
    setL_14_16(data_dimanche_pair.filter((ligne) => ligne[12] && ligne[12].trim().length > 0)
      .map((ligne) => `${ligne[12]} (${ligne[14]}/${ligne[15]})`));
    setL_16_18(data_dimanche_pair.filter((ligne) => ligne[16] && ligne[16].trim().length > 0)
      .map((ligne) => `${ligne[16]} (${ligne[18]}/${ligne[19]})`));
    setL_18_22(data_dimanche_pair.filter((ligne) => ligne[20] && ligne[20].trim().length > 0)
      .map((ligne) => `${ligne[20]} (${ligne[22]}/${ligne[23]})`));
    */
    setL_08_10(data_dimanche_pair.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_10_12(data_dimanche_pair.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));
    setL_12_14(data_dimanche_pair.map((ligne) => ligne[8]).filter(str => str.trim().length > 0));
    setL_14_16(data_dimanche_pair.map((ligne) => ligne[12]).filter(str => str.trim().length > 0));
    setL_16_18(data_dimanche_pair.map((ligne) => ligne[16]).filter(str => str.trim().length > 0));
    setL_18_22(data_dimanche_pair.map((ligne) => ligne[20]).filter(str => str.trim().length > 0));
  }, [data_dimanche_pair]);

  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du dimanche
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_09_11(data_dimanche_impair.filter((ligne) => ligne[0] && ligne[0].trim().length > 0)
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));
    setL_11_13(data_dimanche_impair.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    setL_13_15(data_dimanche_impair.filter((ligne) => ligne[8] && ligne[8].trim().length > 0)
      .map((ligne) => `${ligne[8]} (${ligne[10]}/${ligne[11]})`));
    setL_15_17(data_dimanche_impair.filter((ligne) => ligne[12] && ligne[12].trim().length > 0)
      .map((ligne) => `${ligne[12]} (${ligne[14]}/${ligne[15]})`));
    */
    setL_09_11(data_dimanche_impair.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_11_13(data_dimanche_impair.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));
    setL_13_15(data_dimanche_impair.map((ligne) => ligne[8]).filter(str => str.trim().length > 0));
    setL_15_17(data_dimanche_impair.map((ligne) => ligne[12]).filter(str => str.trim().length > 0));
  }, [data_dimanche_impair]);

  //---------------------------------------------------------------------------
  // mise à jour des données dans le composant parent
  //---------------------------------------------------------------------------
  useEffect(() => {
    onDimancheChange(dimanche);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimanche]);

  //---------------------------------------------------------------------------
  // reset des info du dimanche
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (triggerResetDimanche) {
      setDimanche({
        c_08_10: '',
        c_09_11: '',
        c_10_12: '',
        c_11_13: '',
        c_12_14: '',
        c_13_15: '',
        c_14_16: '',
        c_15_17: '',
        c_16_18: '',
        c_18_22: '',
        repas_midi: false,
      });
    }
  }, [triggerResetDimanche]);

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Stack spacing={1} bgcolor={'#b3cefb'} alignItems={'center'} sx={{ width: '100%' }}>
      <Typography variant="h6" align="center">
        Dimanche
      </Typography>

      {is_benevole && (
        <Stack direction={'row'} sx={{ width: '100%' }}>
          <Stack spacing={1} sx={{ width: '50%' }}>
            <SelectPoste
              label="08h00-10h00"
              value={dimanche.c_08_10}
              onChange={(event) => { setDimanche({ ...dimanche, c_08_10: event.target.value }); }}
              items={l_08_10}
              creneau1={''}
              creneau2={dimanche.c_09_11}
            />

            <SelectPoste
              label="10h00-12h00"
              value={dimanche.c_10_12}
              onChange={(event) => { setDimanche({ ...dimanche, c_10_12: event.target.value }); }}
              items={l_10_12}
              creneau1={dimanche.c_09_11}
              creneau2={dimanche.c_11_13}
            />

            <SelectPoste
              label="12h00-14h00"
              value={dimanche.c_12_14}
              onChange={(event) => { setDimanche({ ...dimanche, c_12_14: event.target.value }); }}
              items={l_12_14}
              creneau1={dimanche.c_11_13}
              creneau2={dimanche.c_13_15}
            />

            <SelectPoste
              label="14h00-16h00"
              value={dimanche.c_14_16}
              onChange={(event) => { setDimanche({ ...dimanche, c_14_16: event.target.value }); }}
              items={l_14_16}
              creneau1={dimanche.c_13_15}
              creneau2={dimanche.c_15_17}
            />

            <SelectPoste
              label="16h00-18h00"
              value={dimanche.c_16_18}
              onChange={(event) => { setDimanche({ ...dimanche, c_16_18: event.target.value }); }}
              items={l_16_18}
              creneau1={dimanche.c_15_17}
              creneau2={''}
            />

            <SelectPoste
              label="18h00-22h00"
              value={dimanche.c_18_22}
              onChange={(event) => { setDimanche({ ...dimanche, c_18_22: event.target.value }); }}
              items={l_18_22}
              creneau1={''}
              creneau2={''}
            />
          </Stack>

          <Stack spacing={1} sx={{ width: '50%' }}>
            <Box sx={{ height: '15px' }} />
            <SelectPoste
              label="09h00-11h00"
              value={dimanche.c_09_11}
              onChange={(event) => { setDimanche({ ...dimanche, c_09_11: event.target.value }); }}
              items={l_09_11}
              creneau1={dimanche.c_08_10}
              creneau2={dimanche.c_10_12}
            />

            <SelectPoste
              label="11h00-13h00"
              value={dimanche.c_11_13}
              onChange={(event) => { setDimanche({ ...dimanche, c_11_13: event.target.value }); }}
              items={l_11_13}
              creneau1={dimanche.c_10_12}
              creneau2={dimanche.c_12_14}
            />

            <SelectPoste
              label="13h00-15h00"
              value={dimanche.c_13_15}
              onChange={(event) => { setDimanche({ ...dimanche, c_13_15: event.target.value }); }}
              items={l_13_15}
              creneau1={dimanche.c_12_14}
              creneau2={dimanche.c_14_16}
            />

            <SelectPoste
              label="15h00-17h00"
              value={dimanche.c_15_17}
              onChange={(event) => { setDimanche({ ...dimanche, c_15_17: event.target.value }); }}
              items={l_15_17}
              creneau1={dimanche.c_14_16}
              creneau2={dimanche.c_16_18}
            />
          </Stack>
        </Stack>
      )}

      <Stack alignItems={'center'} bgcolor={'#e69138'} sx={{ width: '100%' }}>
        <FormControlLabel
          label="Dimanche midi"
          control={
            <Checkbox
              checked={dimanche.repas_midi}
              onChange={(event) => { setDimanche({ ...dimanche, repas_midi: event.target.checked }); }}
            />} />
      </Stack>
    </Stack>

  );
};

Dimanche.propTypes = {
  data_dimanche_pair: PropTypes.any.isRequired,
  data_dimanche_impair: PropTypes.any.isRequired,
  onDimancheChange: PropTypes.any.isRequired,
  triggerResetDimanche: PropTypes.any.isRequired,
  is_benevole: PropTypes.any.isRequired
};

export default Dimanche;